import { ADD_DOCUMENTS, FETCHING_DOCUMENTS, FETCHED_DOCUMENTS, DOCUMENTS_DIRTY } from '../constants';

interface DocumentsState {
  list: Record<string, any[]>;
  fetching: boolean;
  fetched: Record<string, number>;
  /** Per-project upload counter. Bumped (monotonically) on every
   *  successful upload from any screen. Subscribers re-fetch when the
   *  counter for their project changes. See DOCUMENTS_DIRTY constant
   *  for the full rationale (ED-2048). */
  dirty: Record<string, number>;
}

const initialState: DocumentsState = {
  list: {},
  fetching: false,
  fetched: {},
  dirty: {},
};

export default function documentsReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): DocumentsState {
  switch (type) {
    case ADD_DOCUMENTS:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
      };
    case FETCHING_DOCUMENTS:
      return { ...state, fetching: payload };
    case FETCHED_DOCUMENTS:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    case DOCUMENTS_DIRTY: {
      const key = String(payload?.project_id);
      if (!key || key === 'undefined' || key === 'null') return state;
      return {
        ...state,
        dirty: { ...state.dirty, [key]: (state.dirty[key] || 0) + 1 },
      };
    }
    default:
      return state;
  }
}
